module.exports = __webpack_public_path__ + "static/media/secure 1.3fbb2331.svg";